import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=5b974704&"
import script from "./Legal.vue?vue&type=script&lang=ts&"
export * from "./Legal.vue?vue&type=script&lang=ts&"
import style0 from "./Legal.vue?vue&type=style&index=0&id=5b974704&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports